// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Phone = t.struct({
    areaCode: t.String,
    country: t.String,
    extension: t.String,
    id: t.Number,
    number: t.String,
    type: t.String
}, {
    name: 'Phone',
    strict: true
});

export const getDefaultState = () => new Phone({
    areaCode: '',
    country: '',
    extension: '',
    id: 0,
    number: '',
    type: ''
});

export default Phone;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/phone.js